'use client';

import { useEffect, useState } from 'react';

import { Cms } from '@bytel/product-wall';
import { Button, ButtonList, ButtonVariant, ModalBody, ModalFooter } from '@bytel/trilogy-react';

import { getUpsellModal } from '@services/cms/eligibility';

import { FaiUpsellModalProps } from './fai-upsell-modal.props';

export function CmsUpsellModal({ clickedOffer, upsellOffer, onAddOffer }: Readonly<FaiUpsellModalProps>) {
    const [content, setContent] = useState('');

    useEffect(() => {
        getUpsellModal(`${upsellOffer.rangeNg}_${upsellOffer.commercialSeries}`).then((response) =>
            setContent(response ?? ''),
        );
    }, [upsellOffer]);

    return (
        <>
            {content ? (
                <ModalBody>
                    <Cms content={content} />
                </ModalBody>
            ) : null}
            <ModalFooter>
                <ButtonList>
                    <Button variant={ButtonVariant.SECONDARY} onClick={() => onAddOffer?.(clickedOffer)}>
                        Non merci
                    </Button>
                    <Button variant={ButtonVariant.CONVERSION} onClick={() => onAddOffer?.(upsellOffer)}>
                        Oui, je choisis cette offre
                    </Button>
                </ButtonList>
            </ModalFooter>
        </>
    );
}
